module.exports = __webpack_public_path__ + "img/DO.5c0939d0.png";